import { createContext } from "react";

export const ConstantContext = createContext({} as any);
